export default __webpack_public_path__ + "static/media/O-089.a9e83007.png";